<template>
  <v-avatar :color="color" :tile="tile">
    <!-- @slot can be anything, such as an image, single character or icon -->
    <slot></slot>
  </v-avatar>
</template>

<script>
export default {
  name: "NsAvatar",
  props: {
    /**
     * Applies specified color to the control - it can be the name of material color (for example success or purple) or css color (#033 or rgba(255, 0, 0, 0.5)).
     */
    color: {
      type: String
    },
    /**
     * This sets the width and height of the avatar, width and height should be the same
     */
    size: {
      type: String | Number,
      default: 48
    },
    /**
     * This sets the avatar to a `sqaure` look and feel.
     */
    tile: {
      type: Boolean,
      default: false
    }
  }
};
</script>